//import React from 'react';

import Dashboard from './Dashboard';
import BlockMenu from './Kanban';
//
import About from './About';
//import Audit from './Audit';
import Inbox from './Inbox';
import Help from './Help';
import Main from './Main';
import Mapboard from './Mapboard';
import Memboard from './Memboard';
import SearchBoard from './Searchboard';
//import Privilege from './Privilege';
import Password from './Password';
import Profile from './Profile';
//import Role from './Role';
//import Searched from './Searched';
//import User from './User';
import Kanban from './Kanban';
//import ReportService from '../reports/oldReportService';
import Support from './Support';
import Testing from './Testing';
import TestPing from './Testping';
import Maintenance from './Maintenance';
import Performance from '../../components/dash/Performance';
import Rating from '../../components/dash/Rating';
import Compliance from '../../components/dash/Compliance';
import Announcement from './Announcement';
import Inspector from './Inspector';
import Subscription from './Subscription';
import Requisition from './Requisition';
import Review from './Review';
import Approval from './Approval';
import Analysis from './Analysis';

//logout is handled in Home
const pages:any = {
  about: <About />,
  //search: <Searched />,
  dashboard:<Dashboard />,
  searchboard: <SearchBoard />,
  menu: <BlockMenu />,

  help: <Help />,
  
  inbox: <Inbox />,

  kanban: <Kanban />,
  maintenance: <Maintenance/>,

  main: <Main />,
  mapboard: <Mapboard />,
  memboard: <Memboard />,
  password: <Password />,
  profile: <Profile />,

  requisition: <Requisition />,
  formsreview: <Review />,
  formsapproval: <Approval />,
  formsanalytics: <Analysis />,

  subscription: <Subscription />,
  performanceanalytics: <Performance/>,
  ratinganalytics: <Rating/>,
  complianceanalytics: <Compliance/>,
  announcement: <Announcement/>,
  monitor: <Inspector/>,

  //subscriberreport: <ReportService />,
  support: <Support />,

  testapi: <Testing />,
  testping: <TestPing />,
  
};

export default pages;